import React, { useEffect, useState } from "react";
import InstantSearch from "@herb/components/Search/InstantSearch";
import { Index, connectInfiniteHits, Configure } from "react-instantsearch-dom";
import RandomProductCard from "../../Cards/RandomProductCard";
import SidebarProductCard from "../../Cards/SidebarRandomProductCard";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
import usePrefetchedData from "../../../hooks/usePrefetchedData";
import "./index.css";

const CustomHits = connectInfiniteHits(({ hits, productsToShow = 3 }) => {
  let randomHits = [];
  const shuffledHits = [...hits].sort(() => Math.random() - 0.5);
  randomHits = shuffledHits.slice(0, productsToShow);

  return (
    <div className="random">
      {productsToShow === 2
        ? randomHits.map((hit, idx) => {
            return (
              <React.Fragment key={`brand-product-${idx}`}>
                <InstantSearch>
                  <Index indexName="Products">
                    <Configure
                      aroundLatLngViaIP={false}
                      hitsPerPage={1}
                      query="*"
                      filters={`contentProducts.brand.slug:${hit.slug}`}
                    />
                    <CustomBrandHits />
                  </Index>
                </InstantSearch>
              </React.Fragment>
            );
          })
        : randomHits.map((hit, index) => {
            if (index == 2) {
              return (
                <React.Fragment key={`brand-product-binoid-${index}`}>
                  <InstantSearch>
                    <Index indexName="Products">
                      <Configure
                        aroundLatLngViaIP={false}
                        hitsPerPage={5}
                        query="*"
                        filters={`contentProducts.brand.slug:binoid-cbd`}
                      />
                      <CustomProductHits />
                    </Index>
                  </InstantSearch>
                </React.Fragment>
              );
            } else {
              return (
                <React.Fragment key={`brand-product-${index}`}>
                  <InstantSearch>
                    <Index indexName="Products">
                      <Configure
                        aroundLatLngViaIP={false}
                        hitsPerPage={2}
                        query="*"
                        filters={`contentProducts.brand.slug:${hit.slug}`}
                      />
                      <CustomProductHits />
                    </Index>
                  </InstantSearch>
                </React.Fragment>
              );
            }
          })}
    </div>
  );
});

const CustomBrandHits = connectInfiniteHits(({ hits }) => {
  return (
    <React.Fragment>
      <div className="randomProductCardContainer">
        {hits.map((product, idx) => {
          return <SidebarProductCard productdetails={product} key={`sidebar-product-${idx}`} />;
        })}
      </div>
    </React.Fragment>
  );
});

const CustomProductHits = connectInfiniteHits(({ hits }) => {
  const randomNumber = Math.floor(Math.random() * hits.length);
  const binoidHits =
    hits.length > 1 ? [...hits].sort(() => Math.random() - 0.5) : [];
  const randomHits = binoidHits.length > 0 ? [binoidHits[randomNumber]] : [];
  if (randomHits.length > 0) {
    return (
      <React.Fragment>
        <div className="randomProductCardContainer">
          <div>
            {randomHits.map((product, idx) => {
              return <RandomProductCard productdetails={product} key={`random-product-${idx}`} />;
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <div className="randomProductCardContainer">
        <div>
          {hits.map((product, idx) => {
            return <RandomProductCard productdetails={product} key={`random-product-${idx}`} />;
          })}
        </div>
      </div>
    </React.Fragment>
  );
});

const LoadRandomProducts = ({ productsToShow, lazyLoad = true }) => {
  // Lazy-load this component - only fetch when scrolled into view
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const renderContent = () => (
    <InstantSearch>
      <Index indexName="Brands">
        <Configure
          aroundLatLngViaIP={false}
          hitsPerPage={20}
          query="*"
          filters={
            'isBrandActive.brandActive:true AND NOT title:"Binoid CBD"'
          }
        />
        <CustomHits productsToShow={productsToShow} />
      </Index>
    </InstantSearch>
  );

  // Wrap with lazy-loading if enabled
  if (lazyLoad) {
    return (
      <div ref={ref}>
        {isVisible ? renderContent() : <div css={{ minHeight: "150px" }} />}
      </div>
    );
  }

  return renderContent();
};

export default LoadRandomProducts;
